var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper",
    class: {
      'wrapper--details': _vm.details
    }
  }, [_c('v-card', {
    staticClass: "inventory-status",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "no-gutters": ""
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [index != 0 ? _c('v-col', {
      key: `divider-${index}`,
      staticClass: "d-none d-md-block",
      attrs: {
        "cols": "auto"
      }
    }, [_c('div', {
      staticClass: "h-100 py-18px py-md-24px"
    }, [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1)]) : _vm._e(), _c('v-col', {
      key: item.text,
      attrs: {
        "cols": "4",
        "md": ""
      }
    }, [_c('v-card', _vm._b({
      staticClass: "py-18px py-md-24px",
      attrs: {
        "tile": "",
        "color": "transparent",
        "loader-height": "100%"
      }
    }, 'v-card', {
      loading: _vm.loading
    }, false), [_c('div', {
      staticClass: "d-flex flex-column align-center"
    }, [_c('v-avatar', {
      staticClass: "mb-8px mb-12px",
      attrs: {
        "size": _vm.$vuetify.breakpoint.mobileBreakpoint ? '60' : '40',
        "color": "white"
      }
    }, [_c('v-img', {
      staticClass: "rounded-0",
      attrs: {
        "src": item.icon,
        "max-width": "36",
        "height": "auto",
        "alt": ""
      }
    })], 1), _c('div', {
      staticClass: "font-size-14 font-size-md-16 font-weight-medium line-height-1 grey--text text--darken-4"
    }, [_vm._v(_vm._s(item.text))]), _c('div', {
      staticClass: "font-size-20 font-size-lg-28 font-weight-bold grey--text text--darken-4 mt-8px mt-md-12px"
    }, [_vm._v(_vm._s(item.value))])], 1)])], 1)];
  })], 2)], 1), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }